module.exports = __webpack_public_path__ + "static/media/p4_img6.04a2332d.svg";